module.exports = __webpack_public_path__ + "media/images/categories/icon_cat2-c55b8f02a832d32cec5f11dff53ca2d8.svg";